// /* Click to Expand
//  * - When an `.expand-image-block` is clicked, make it `.active`.
//  * - If the clicked block is already active, do nothing.
//  * - Adds keyboard accessibility (Enter / Space) and focusability.
//  */

// document.addEventListener('DOMContentLoaded', function () {
//   document.querySelectorAll('.click-to--expand-section').forEach(function (section) {
//     const container = section.querySelector('.expand-images-blocks');
//     if (!container) return;

//     // Ensure each block is focusable and has button semantics for accessibility
//     container.querySelectorAll('.expand-image-block').forEach(function (block) {
//       if (!block.hasAttribute('tabindex')) block.setAttribute('tabindex', '0');
//       if (!block.hasAttribute('role')) block.setAttribute('role', 'button');
//     });

//     // Click handler (delegated)
//     container.addEventListener('click', function (event) {
//       const block = event.target.closest('.expand-image-block');
//       if (!block || !container.contains(block)) return;
//       // If already active, do nothing
//       if (block.classList.contains('active')) return;
//       const current = container.querySelector('.expand-image-block.active');
//       if (current) current.classList.remove('active');
//       block.classList.add('active');
//     });

//     // Keyboard handler for Enter / Space
//     container.addEventListener('keydown', function (event) {
//       if (event.key !== 'Enter' && event.key !== ' ') return;
//       const block = event.target.closest('.expand-image-block');
//       if (!block || !container.contains(block)) return;
//       event.preventDefault();
//       if (block.classList.contains('active')) return;
//       const current = container.querySelector('.expand-image-block.active');
//       if (current) current.classList.remove('active');
//       block.classList.add('active');
//     });
//   });
// });
/* Click to Expand (Desktop only ≥1024px)
 * - Click a block to make it active
 * - Only one block active at a time
 * - Keyboard accessible (Enter / Space)
 */

document.addEventListener('DOMContentLoaded', function () {

  // Loop through each section
  document.querySelectorAll('.click-to--expand-section').forEach(function (section) {

    const container = section.querySelector('.expand-images-blocks');
    const scrollWrapper = section.querySelector('.expand-images-blocks-container');
    if (!container) return;

    const blocks = container.querySelectorAll('.expand-image-block');

    // Make blocks focusable + accessible
    blocks.forEach(function (block) {
      block.setAttribute('tabindex', '0');
      block.setAttribute('role', 'button');
    });

    // Function to activate a block (Desktop)
    function activateBlock(block) {
      if (window.innerWidth < 1024) return;
      if (block.classList.contains('active')) return;

      const current = container.querySelector('.expand-image-block.active');
      if (current) current.classList.remove('active');

      block.classList.add('active');
    }

    // Scroll reveal logic for mobile
    window.addEventListener('scroll', function() {
      if (window.innerWidth >= 1025) {
        // Reset transforms if resized to desktop
        if (blocks[1]) blocks[1].style.transform = '';
        return;
      }
      
      if (!scrollWrapper) return;

      const rect = scrollWrapper.getBoundingClientRect();
      const scrollStart = 0; // Relative to viewport top when section reaches sticky point
      const scrollEnd = -scrollWrapper.offsetHeight + window.innerHeight; // When section ends

      // Calculate progress (0 to 1) based on sticky container's position
      let progress = 0;
      if (rect.top <= 0) {
        progress = Math.abs(rect.top) / (scrollWrapper.offsetHeight - window.innerHeight);
      }
      progress = Math.min(Math.max(progress, 0), 1);

      if (blocks[1]) {
        // Slide from 100% to 0%
        const translateVal = 100 - (progress * 100);
        blocks[1].style.transform = `translateX(${translateVal}%)`;
      }
    });

    // Hover handler (Desktop)
    container.addEventListener('mouseover', function (event) {
      const block = event.target.closest('.expand-image-block');
      if (!block || !container.contains(block)) return;
      activateBlock(block);
    });

    // Keyboard handler (Enter / Space)
    container.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;

      const block = event.target.closest('.expand-image-block');
      if (!block || !container.contains(block)) return;

      event.preventDefault();
      activateBlock(block);
    });

  });

});
